class WishlistTrigger extends HTMLElement {
  connectedCallback () {
    this.wishlistTrigger = this.querySelector('[data-wishlist-trigger]')
    this.wishlistAccountTrigger = this.querySelector('[data-wishlist-account-trigger]')
    this.wishlistQuickAddTrigger = this.querySelector('[data-wishlist-quick-add-trigger]')
    this.setupListeners()
  }

  setupListeners () {
    if (this.wishlistTrigger) {
      this.wishlistTrigger.addEventListener('click', this.handleAddToWishlist.bind(this))
    }

    if (this.wishlistAccountTrigger) {
      this.wishlistAccountTrigger.addEventListener('click', this.handleAccountTrigger.bind(this))
    }

    if (this.wishlistQuickAddTrigger) {
      this.wishlistQuickAddTrigger.addEventListener('click', this.handleQuickAddTrigger.bind(this))
    }

    if (window.theme.wishlist.initialized) {
      this.setAttribute('aria-hidden', 'false')
    }

    window.addEventListener(window.theme.wishlist.eventBus.wishlist_ready, () => {
      this.setAttribute('aria-hidden', 'false')
    })

    window.addEventListener('wishlist-trigger:update', this.handleStateUpdate.bind(this))
  }

  setWishlistAddedState (state) {
    const textNode = this.wishlistTrigger.querySelector('[data-wishlist-trigger-text]')
    this.wishlistTrigger.setAttribute('data-wishlist-added', state)

    state ? textNode.textContent = window.wishlistStrings.addedToWishlist : textNode.textContent = window.wishlistStrings.addToWishlist
  }

  handleAddToWishlist () {
    const productForm = this.closest('.product-form')
    const selectedVariantId = productForm?.querySelector('[name="id"]').value

    if (productForm && selectedVariantId === '') {
      this.handleErrorState()
      return
    }

    const data = {
      productId: Number(this.wishlistTrigger.dataset.productId),
      variantId: Number(this.wishlistTrigger.dataset.variantId),
      productUrl: this.wishlistTrigger.dataset.productUrl,
    }
    if (this.wishlistTrigger.dataset.wishlistAdded === 'false') {
      window.theme.wishlist.addToWishlist(data.variantId, data.productId, data.productUrl)
      this.setWishlistAddedState(true)
    } else {
      window.theme.wishlist.removeFromWishlist(data.variantId, data.productId, data.productUrl)
      this.setWishlistAddedState(false)
    }
  }

  handleAccountTrigger () {
    document.querySelector('#PopupModal-modalWishlistLogin').setAttribute('open', true)
    sessionStorage.setItem('lastClickedProductCard', this.closest('fostr-product-card').id)
  }

  handleQuickAddTrigger () {
    const relatedQuickAddComponent = this.closest('fostr-product-card').querySelector('vbf-wishlist-quick-add')
    const relatedStandardQuickAddComponent = this.closest('fostr-product-card').querySelector('quick-buy')
    relatedQuickAddComponent.setAttribute('aria-hidden', false)
    relatedStandardQuickAddComponent.style.display = 'none'
  }

  handleErrorState () {
    if (this.querySelector('[data-fostr-variant-radios="wishlistError"]')) return
    this.wishlistTrigger.insertAdjacentHTML('afterend', `<p class="product-form__error" data-fostr-variant-radios="wishlistError">${window.wishlistStrings.selectSize}</p>`)
  }

  handleStateUpdate (e) {
    if (!window.theme.wishlist.products) return
    const variantId = Number(e.detail.variantId)
    const isRelatedProductInWishlist = !!window.theme.wishlist.products.find(product => product.epi === variantId)
    this.wishlistTrigger.setAttribute('data-variant-id', variantId)

    this.setWishlistAddedState(isRelatedProductInWishlist)
  }
}

customElements.define('wishlist-trigger', WishlistTrigger)
